import { BrowserAgent } from '@newrelic/browser-agent/loaders/browser-agent';
// disabled in nodejs threads
const hasDOM = typeof window !== 'undefined';
const debug = process.env.REACT_APP_MODE === 'dev';
let optIn = false;
let browserAgent = null;
const hasAllRequiredValues = (config) => {
    return (config.accountID &&
        config.agentID &&
        config.applicationID &&
        config.licenseKey &&
        config.trustKey);
};
const init = ({ config, metadata, appVersion }) => {
    if (debug) {
        console.log('newRelicApi.init()');
    }
    if (!hasDOM || !hasAllRequiredValues(config)) {
        console.log('NewRelic disabled in context');
        return;
    }
    try {
        browserAgent = new BrowserAgent({
            info: {
                beacon: 'bam.nr-data.net',
                errorBeacon: 'bam.nr-data.net',
                sa: 1,
                licenseKey: config.licenseKey,
                applicationID: config.applicationID
            },
            init: {
                ajax: {
                    deny_list: ['bam.nr-data.net', 'api-js.mixpanel.com']
                },
                distributed_tracing: {
                    enabled: true
                },
                privacy: {
                    cookies_enabled: false
                }
            },
            loader_config: config
        });
        browserAgent.setApplicationVersion(appVersion);
        metadata && register(metadata);
    }
    catch (e) {
        console.log('NewRelic initialization failed', e);
    }
};
const updateTracking = (track) => {
    if (debug) {
        console.log('newRelicApi.updateTracking()', track);
    }
    if (!hasDOM || !browserAgent) {
        return;
    }
    optIn = track;
};
const onLogin = (externalId) => {
    if (debug) {
        console.log('newRelicApi.onLogin()', externalId);
    }
    if (!hasDOM || !browserAgent) {
        return;
    }
    try {
        browserAgent.setUserId(externalId);
    }
    catch (e) {
        console.log(e);
    }
};
const onLogout = () => {
    if (debug) {
        console.log('newRelicApi.onLogout()');
    }
    if (!hasDOM || !browserAgent) {
        return;
    }
    try {
        browserAgent.setUserId(null);
    }
    catch (e) {
        console.log(e);
    }
};
const event = (name, properties = {}) => {
    if (debug) {
        console.log('newRelicApi.event()', name, properties);
    }
    if (!hasDOM || !browserAgent || !optIn) {
        return;
    }
    try {
        browserAgent.addPageAction(name, properties);
    }
    catch (e) {
        console.log(e);
    }
};
const register = (properties) => {
    setProperties(properties);
};
const setProperties = (properties) => {
    if (debug) {
        console.log('newRelicApi.setProperties()', properties);
    }
    if (!hasDOM || !browserAgent) {
        return;
    }
    try {
        const props = Object.entries(properties);
        for (let i = 0; i < props.length; i++) {
            browserAgent.setCustomAttribute(props[i][0], props[i][1], false);
        }
    }
    catch (e) {
        console.log(e);
    }
};
export const newRelicApi = {
    init,
    updateTracking,
    onLogin,
    onLogout,
    register,
    event,
    setProperties
};
//# sourceMappingURL=newRelic.js.map